<template>

    <div><!--消耗退回-->
        <el-table class="table"
                  border
                  ref="multipleTable"
                  :data="tableData"
                  height="496"
                  :key="tableId"
                  size="mini"
                  tooltip-effect="dark">
            <el-table-column
                    :label="$t('form_serial_number')"
                    align="left"
                    type="index"
                    width="55">
            </el-table-column>
            <!--<el-table-column
                    align="left"
                    prop="vc_gsname"
                    label="公司"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    align="left"
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_no"
                    :label="$t('form_batch_number')"
                    width=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_no_hs"
                    :label="$t('promanagement_cost_accounting_batch')"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_unit"
                    :label="$t('form_unit')"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_num"
                    :label="$t('form_quantity')"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    align="left"
                    prop="f_zx"
                    label="在线"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    align="left"
                    prop="f_zbxs"
                    label="折百比"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    align="left"
                    prop="f_thnum"
                    :label="$t('promanagement_returned_quantity')"
                    width="120">
                <template slot-scope="scope">
                    <!--                    <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_num'">-->
                    <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_thnum" @change="thChange(scope.row,scope.$index)"></el-input-number>
                    <!--                    </el-form-item>-->
                </template>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_syzx"
                    :label="$t('promanagement_remaining_online')"
                    width="80"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" style="text-align: center">

            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
            <!--            <el-button type="primary" @click="toApprove" v-if="state==0" :disabled="disabled" :class="baseerp+'btn'">提交审批</el-button>-->
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "ConsumptionReturn",
        props:{
            returnlist:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                dt_accounttime:'',
                baseerp:"",
                tableData:[],
                i_pid:0,
                disabled:false,
                tableId:0,
                pageSize:1,
                mid:0,
            }
        },
        watch: {
            returnlist: {
                handler() {
                    if (this.returnlist) {
                        this.mid=this.returnlist.i_mid;
                        this.pageSize=this.returnlist.page_size;
                        this.form=this.returnlist.taskDa;
                        let dtnowtime = `${this.returnlist.taskDa.dt_createtime.slice(0, 4)}-${this.returnlist.taskDa.dt_createtime.slice(4, 6)}-${this.returnlist.taskDa.dt_createtime.slice(6, 8)}`;
                        let dtendtime = `${this.returnlist.taskDa.dt_endtime.slice(0, 4)}-${this.returnlist.taskDa.dt_endtime.slice(4, 6)}-${this.returnlist.taskDa.dt_endtime.slice(6, 8)} 23:59:59`;
                        this.dt_accounttime=this.returnlist.jz==false?dtendtime:dtnowtime;
                        this.edit=false;
                        this.getXhThList();
                        // console.log(this.returnlist, "this.returnlist");
                    }
                },
                immediate: true,
                deep: true
            }
        },
        mounted() {
            this.baseerp=baseerp;
        },
        methods: {
            //列表
            async getXhThList(){
                let param={
                    i_mid: this.mid,
                    i_rwid:this.form.i_id,
                    i_gsid:this.form.i_gsid,

                };
                let res=await API.getXhThList(param);
                if(res.code==1){
                    this.tableData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            thChange(val,index){
                // console.log(this.tableData[index].f_thnum,index,"退回")
                if (this.tableData[index].f_num<this.tableData[index].f_thnum){
                    this.$message.error(this.$t('promanagement_the_return_quantity_shall_not_exceed_the_quantity'));
                    this.tableData[index].f_thnum=this.tableData[index].f_num;
                }
                this.tableData[index].f_syzx=this.$math.subtract(this.tableData[index].f_num,this.tableData[index].f_thnum);
                this.tableId=Math.random();

            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

            },
            //保存
            async saveForm(){
                let details = this.tableData.filter(item=>item.f_thnum!=0);
                if (details.length==0){
                    this.$message.error(this.$t('promanagement_please_fill_in_the_quantity_to_be_returned'))
                    return ;
                }
                this.disabled=true;
                // console.log("details",details)
                let param={
                    i_mid: this.mid,
                    i_rwid:this.form.i_id,
                    i_gsid:this.form.i_gsid,
                    i_cjid:this.form.i_cjid,
                    i_ckid:this.form.i_ckid,
                    i_pzid:this.form.i_pzid,
                    i_lruid:sessionStorage.getItem("userid"),
                    vc_lruname:sessionStorage.getItem("lruname"),
                    details:details,
                    dt_accounttime:this.dt_accounttime,
                    i_type:this.form.i_type,
                };
                let res=await API.saveXhTh(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.$emit('getConsumeList',this.pageSize);

                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    /deep/{
    }
</style>